/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：185
 */

"use strict"

export { r as o }
export { i as n }
export { o as m }
export { a as i }
export { s as k }
export { c as a }
export { u as h }
export { l as g }
export { f }
export { d as l }
export { h as j }
export { p as d }
export { _ as b }
export { A as c }
export { g as e }
function r(e) {
  return e / 10
}
function i(e) {
  return 10 * e
}
function o(e, t) {
  return e + "---" + t
}
var a = 6e3
var s = 5
var c = 1
var u = 1e3
var l = 0
var f = 1 / 60
var d = 8
var h = 3
var p = 10
var _ = 1
var A = .1
var g = 0
export default c
